import { VictorReadonly } from "@spawn/common";
import { ITextOptions, SpriteBase } from "@spawn/core";
import Color from "color";
import PixiTaggedText from "pixi-tagged-text";
/*eslint no-restricted-imports: "off"*/
import { TaggedTextOptions, TextStyleExtended } from "pixi-tagged-text/dist/types";

export class TaggedText extends SpriteBase<PixiTaggedText> {
	public constructor(defaultTextStyle: ITextOptions, options?: TaggedTextOptions, extendedTextStyle?: TextStyleExtended) {
		super(
			new PixiTaggedText(
				defaultTextStyle.text ?? "NO TEXT",
				{
					default: { ...TaggedText.convertStyleOptions(defaultTextStyle), ...extendedTextStyle },
				},
				{
					...options,
				}
			),
			defaultTextStyle.layout
		);
	}

	public get realFontSize(): number {
		return this._pixiObject.tokensFlat[0].fontProperties.fontSize;
	}

	public set scale(scale: VictorReadonly) {
		this._pixiObject.scale = scale.toObject();
	}

	public get scale(): VictorReadonly {
		return super.scale;
	}

	public static convertStyleOptions(textOptions: ITextOptions): TextStyleExtended {
		const style: TextStyleExtended = {
			align: textOptions.align,
			breakWords: true,
			color: Array.isArray(textOptions.color) ? undefined : textOptions.color?.rgbNumber(),
			dropShadow: textOptions.dropShadow,
			dropShadowAlpha: textOptions.dropShadowAlpha,
			dropShadowAngle: textOptions.dropShadowAngle,
			dropShadowBlur: textOptions.dropShadowBlur,
			dropShadowColor: textOptions.dropShadowColor?.rgbNumber(),
			dropShadowDistance: textOptions.dropShadowDistance,
			fill: Array.isArray(textOptions.color)
				? textOptions.color.map((value) => value.rgbNumber())
				: textOptions.color?.rgbNumber(),
			fillGradientType: textOptions.fillGradientType as number,
			fillGradientStops: textOptions.fillGradientStops,
			fontFamily: [textOptions.font.fontFamily, "Arial"],
			fontSize: textOptions.fontSize,
			fontWeight: textOptions.fontStyle === "bold" ? "700" : undefined,
			iconScale: 1,
			imgDisplay: "inline",
			lineJoin: textOptions.lineJoin,
			stroke: textOptions.stroke instanceof Color ? textOptions.stroke.rgbNumber() : textOptions.stroke,
			strokeThickness: textOptions.strokeThickness,
			textBaseline: textOptions.baseline,
			valign: "middle",
			wordWrap: textOptions.wordWrap,
			wordWrapWidth: textOptions.wordWrapWidth,
		};

		return Object.fromEntries(Object.entries(style).filter(([_, v]) => v !== null));
	}
}
